module.exports = __webpack_public_path__ + "static/img/12areaA_03.93006db.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/文字バージョン/12areaA_03.png
// module id = 964
// module chunks = 1